import { render, staticRenderFns } from "./stepFour.vue?vue&type=template&id=6a9e4172"
import script from "./stepFour.vue?vue&type=script&lang=js"
export * from "./stepFour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports